import React, { Component } from 'react';
import { Form, ListGroup, Modal, Button } from 'react-bootstrap';
import tick from '../../assets/img/icons/tick.svg';
import axios from 'axios';
import ls from "local-storage";
import Cookies from 'universal-cookie';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Language extends Component {
    constructor(props) {
        super(props);
        this.onSubmitLanguage = this.onSubmitLanguage.bind(this);
        this.state = {
            selectedLanguage: [],
            languages_data: [],
            api_url: localStorage.getItem('api_url'),
            langKey: ls.get('LangValue'),
        };
    }

    componentDidMount() {
		axios.get(this.state.api_url+`admindatas`)
        .then(res => {
            const languages_data = res.data.result.languages;
            this.setState({ languages_data});	
        });
        if(localStorage.getItem('session_userid') !== '' && localStorage.getItem('session_userid') !== null) {
            let data = new FormData(); 
            data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
            data.append('language', this.state.langKey);

            axios({
                method: 'post',
                url: this.state.api_url+'webprofile',
                data: data, 
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
                const user_details = res.data.result;
                if(res.data.status === 'true') {
                    this.setState({ selectedLanguage: user_details.language2 });
                    localStorage.setItem('selected_language', this.state.selectedLanguage);
                } else if(res.data.status === 'error' || res.data.status === 'false') {
                    const cookies = new Cookies();
                    cookies.set('onboarded', 'false', { path: "/" });
                    cookies.set('signuptab', false);
                    localStorage.removeItem('session_token');
                    localStorage.removeItem('session_userid');
                    localStorage.clear();
                    this.props.history.push("/")
                    window.location.reload();
                }
            });
        }
	}

    handleItemClick = (language) => {
        // this.setState({ selectedLanguage: language });
        const { selectedLanguage } = this.state;
        if (selectedLanguage.includes(language)) {
            this.setState({
                selectedLanguage: selectedLanguage.filter(item => item !== language),
            });
        } else {
            this.setState({
                selectedLanguage: [...selectedLanguage, language],
            });
        }
    }

    onSubmitLanguage = (e) => {
    	e.preventDefault();
    	if (this.state.selectedLanguage === null || this.state.selectedLanguage === '' || this.state.selectedLanguage.length === 0) {
        	this.setState({ nolanguage: 'Please select the language' });
            setTimeout(() => {
                this.setState({
                    nolanguage: ''
                });
            }, 2000);
   	 	} else {
            localStorage.setItem('selected_language', this.state.selectedLanguage);
            this.props.handleClose();
	    }
	};

    render() {
        const { selectedLanguage } = this.state;
        return (
            <div className="">
                <Modal className="modal_div" show={this.props.showModal} onHide={this.props.handleClose} centered>
                    <Form className="" onSubmit={this.onSubmitLanguage}>
                        <Modal.Header>
                            <Modal.Title>
                                <Trans i18nKey="Language">Language</Trans>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal">
                            <div>
                                <ListGroup>
                                    {this.state.languages_data.map(language => (
                                        <ListGroup.Item
                                            key={language.name}
                                            active={selectedLanguage.includes(language.name.toString()) === true}
                                            onClick={() => this.handleItemClick(language.name.toString())}
                                        >
                                            {language.name}
                                            <img src={tick} alt="img" />
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.nolanguage}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button type="submit" className='button_primary'>
                                <Trans i18nKey="Save">Save</Trans>
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Language;
